import React from "react";
import { useTranslation } from "../hooks/useTranslation";

const formatPrice = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  const num = Number(value);
  if (!Number.isFinite(num)) return "-";
  return num.toFixed(2);
};

const PriceMatricsListCompact = ({ sellPrice, cost, margin }) => {
  const { t } = useTranslation();
  const hasMargin = margin !== null && margin !== undefined && margin !== "" && Number.isFinite(Number(margin));
  const marginNumber = hasMargin ? Number(margin) : null;
  const marginClass = !hasMargin
    ? "bg-yellow-100 text-yellow-700"
    : marginNumber >= 0
      ? "bg-emerald-100 text-emerald-700"
      : "bg-rose-100 text-rose-700";

  return (
    <div className="inline-flex items-center gap-1.5 text-xs">
      <span className="px-1.5 py-0.5 rounded bg-gray-100 text-gray-600">
        {t("Fs")}: {formatPrice(sellPrice)}
      </span>
      <span className="px-1.5 py-0.5 rounded bg-gray-100 text-gray-600">
        {t("Ik")}: {formatPrice(cost)}
      </span>
      <span className={`px-1.5 py-0.5 rounded ${marginClass}`}>
        {t("M")}: {hasMargin ? formatPrice(margin) : t("Ofullständig")}
      </span>
      <span className="text-gray-500">kr</span>
    </div>
  );
};

export default PriceMatricsListCompact;
